import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMenuitemComponent } from './app.menuitem.component';
import { MenuService } from '../_services/menu.service';
import { firstValueFrom } from 'rxjs';
import { StorageService } from '../_services/storage.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitemComponent],
  templateUrl: './app.menu.component.html',
  styleUrl: './app.menu.component.scss',
})
export class AppMenuComponent implements OnInit {
  menuService = inject(MenuService);
  storageService = inject(StorageService);
  model: any[] = [];

  async ngOnInit() {
    var role = this.storageService.getUser().roleCode
    var resp = await firstValueFrom(this.menuService.GetMenuByRoleCode(role));

    // resp.menus.push({
    //   menuName: "DashBoard",
    //   details: [
    //     {
    //       menuName: "Report",
    //       menuUrl: "/report/report-dashboard",
    //       menuIcon: "pi pi-fw pi-chart-bar",
    //     },
    //   ],
    // });
    resp.menus.unshift({
      menuName: "Main",
      details: [
        {
          menuName: "Main",
          menuUrl: "",
          menuIcon: "pi pi-fw pi-home",
        },
        
        
      ],
      
    });
    
    resp.menus.forEach((menu) => {
        if(menu.menuName==="USER MANAGEMENT")
        {
          menu.details.push({
            menuName: "ข้อมูลผู้ใช้งานสาขา",
            menuUrl: "/user-manage/user-branch-list",
            menuIcon: "pi pi-fw pi-users",
          });
        }    
      this.model.push({
        label: menu.menuName,
        items: menu.details.map((detail) => {
          return {
            label: detail.menuName,
            icon: detail.menuIcon,
            routerLink: [detail.menuUrl],
          };
        }),
      });
    });

  }
}
